import React, { Fragment, useEffect, useState } from 'react';
import { Typography, Space, Row, Col, Radio, Avatar, Input } from 'antd';
import { useHistory } from 'react-router-dom';
import { getPublicSiteImageSrc } from 'Client/common/utils/AppUtils';



const CardsThree = ({ thirdPartyAdmin, handleRadioSelection, handleContactPersonInput }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  return (
    <>
      <div className="ant-result-title">
        <Fragment>
          <Typography.Title level={2} className="cards-heading">
            <Space>
              <Avatar 
                style={{ backgroundColor: '#074079', size: 'large' }} 
                size={{ xs: 32, sm: 32, md: 36, lg: 36, xl: 36, xxl: 36}}
                aria-label="Step 3"
              >
                3
              </Avatar> 
              <span className="avatar-text" id="third-party-admin-heading">Do you use a third-party administrator, or do you want to connect directly to Anthem?</span>
            </Space>
          </Typography.Title>
        </Fragment>
      </div>
      <Row gutter={{sm: 16, md: 24}}>
          <Col span={24}>
            <Radio.Group 
              name="thirdPartyAdmin" 
              onChange={handleRadioSelection} 
              value={thirdPartyAdmin} 
              style={{width: '100%'}}
              role="radiogroup"
              aria-labelledby="third-party-admin-heading"
            >
                <Space size="large">
                  <Row 
                    gutter={[{xs:8, md:16},16]} 
                    className="qna-radiobutton qna-big-card" 
                    type="flex" 
                    justify="space-around" 
                    align="middle"
                  >
                    <Col offset={4} span={12} className="qna_image_container">
                      <img
                          src={getPublicSiteImageSrc('third_party_admin.svg')}
                          alt="Third-party administrator icon"
                          className="qna_image"
                          aria-hidden="true"
                        />
                    </Col>
                    <Col xs={{span: 24}} md={{offset: 4, span: 20}}>
                      <Radio value={true} aria-label="Use third-party administrator">
                          <span className='qna-value'>Third-party administrator</span>
                      </Radio>
                    </Col>
                  </Row>
                  <Col md={12} lg={6}>
                    <Row 
                      gutter={[8,8]} 
                      className="qna-radiobutton qna-big-card" 
                      type="flex" 
                      justify="space-around" 
                      align="middle"
                    >
                      <Col gutter={[{xs:8, md:16},16]} className="qna_image_container">
                        <img
                            src={getPublicSiteImageSrc('not_third_party_admin.svg')}
                            alt="Connect directly to Anthem icon"
                            className="qna_image"
                            aria-hidden="true"
                          />
                      </Col>
                      <Col offset={4} span={20}>
                        <Radio value={false} aria-label="Connect directly to Anthem">
                            <span className='qna-value'>Connect directly to Anthem</span>
                        </Radio>
                      </Col>
                    </Row>
                 </Col>
              </Space>
            </Radio.Group>
          </Col>
      </Row>
      {
        thirdPartyAdmin === false && (
          <Row>
            <Col span={24}>
              <div className='thirdparty-admin-subtitle'>
                <p>
                  <span>Anthem Contact Name</span> <span>(Optional)</span>
                </p>
                <Input 
                  placeholder="Enter Anthem Contact Name" 
                  onChange={handleContactPersonInput}
                  aria-label="Anthem Contact Name (Optional)"
                />
              </div>
            </Col>
          </Row>
        )
      }
    </>
  );
};

export default CardsThree;
